module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-9-svgrepo-com.c9654ad3.svg";